import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';
import { updateFiles } from '../../file/updateFiles';
import { uploadSelector } from '../../../utils/pageHelpers';

export function* update({ payload: { companyId, values, sectionKey } }) {
  try {
    const { uploadKeys, ...dirtyValues } = values;
    const formValues = Object.keys(dirtyValues).reduce(
      (acc, item) => (uploadKeys.includes(item) ? acc : { ...acc, [item]: dirtyValues[item] }),
      {},
    );

    // update files
    if (uploadKeys.length) {
      yield all(
        uploadKeys.map(
          key =>
            (values[key].createList.length || values[key].deleteList.length) &&
            call(updateFiles, {
              companyId,
              deleteList: values[key].deleteList,
              createList: values[key].createList,
              sectionKey: key,
            }),
        ),
      );
    }

    const fileObj = yield select(store => uploadSelector(store, uploadKeys));

    const { data } = yield call(
      dataProvider.updateOnly,
      `companies/${companyId}/insurance-policies`,
      formValues,
    );
    yield put({
      type: currentCompany.insurancePolicy.update.end,
      payload: { ...data, ...fileObj, uploadKeys },
    });

    // update PQF document validation
    yield put({
      type: currentCompany.companyInfo.validation.start,
      payload: { companyId: companyId, validationKey: sectionKey },
    });
  } catch (e) {
    yield put({ type: currentCompany.insurancePolicy.update.error });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* updateInsurancePolicySaga() {
  yield takeLatest(currentCompany.insurancePolicy.update.start, update);
}
